/// <reference path="./dto/com.rico.sb2.service.system.ts" />

import {WebSocketClient} from "./WebSocketClient";
import JournalListItem = com.rico.sb2.service.system.JournalListItem;
import {createJournalEventElement, journalLevelOrdinalOrDefault, updateJournalEventsAgo} from "./JournalEventView";

const EVENTS_LIMIT = 100;

function maxLevelOfEvents(a: string, b: string) {
	// console.info([a, b]);
	if (a === '') return b;
	if (b === '') return a;

	const weights: { [key: string]: number } = {
		'TRACE': -1,
		'WARNING': 1,
		'ERROR': 2,
	};

	const aWeight = a in weights ? weights[a] : 0;
	const bWeight = b in weights ? weights[b] : 0;
	return (bWeight > aWeight) ? b : a;
}

export class JournalOffscreen {
	private readonly list: HTMLElement;
	private readonly minLevel: null | string;
	private unread = 0
	private unreadMaxLevel = ''

	constructor(list: HTMLElement, minLevel: null | string = null) {
		this.list = list;
		this.minLevel = minLevel ?? 'INFO';

		WebSocketClient
			.instance()
			.subscribe('/topic/journal', m => this.onEvent(m))

		setInterval(this.updateAgo.bind(this), 30000);


		this.offcanvas?.addEventListener('hide.bs.offcanvas', () => {
			this.unread = 0;
			this.unreadMaxLevel = '';
			this.unreadUpdate();
			this.list.querySelectorAll<HTMLElement>('.event-unread').forEach(element => element.classList.remove('event-unread'));
		})
		this.offcanvas?.addEventListener('show.bs.offcanvas', () => {
			this.updateAgo();
		})
	}

	get offcanvas() {
		return this.list.closest('.offcanvas');
	}

	get shown() {
		return this.offcanvas?.classList.contains('show') || false;
	}

	private updateAgo() {
		updateJournalEventsAgo(this.list);
	}

	private onEvent(m: JournalListItem) {
		if (journalLevelOrdinalOrDefault(m.level) < journalLevelOrdinalOrDefault(this.minLevel))
			return;

		this.list.prepend(createJournalEventElement(m, true));

		while (this.list.childElementCount > EVENTS_LIMIT) {
			this.list.children.item(this.list.children.length - 1)?.remove();
		}

		if (this.shown) {
			return;
		}

		this.unread += 1;
		this.unreadMaxLevel = maxLevelOfEvents(this.unreadMaxLevel, m.level);
		this.unreadUpdate();
	}

	private unreadUpdate() {
		document.querySelectorAll<HTMLElement>('[data-bind="unreadEventsCount"]').forEach(element => {
			element.innerText = this.unread.toString();
		});
		document.querySelectorAll<HTMLElement>('[data-bind="unreadEventsAvailable"]').forEach(element => {
			if (this.unread > 0) {
				element.removeAttribute('hidden');
			} else {
				element.setAttribute('hidden', 'hidden');
			}
			element.classList.remove('max-', 'max-TRACE', 'max-INFO', 'max-ERROR', 'max-WARNING');
			element.classList.add(`max-${this.unreadMaxLevel}`)
		});
	}

	static setUp(minLevel: string) {
		const list = document.getElementById('offcanvasEvents');
		if (list == null) {
			return;
		}
		new JournalOffscreen(list, minLevel);
	}
}
